import isEmpty from "lodash/isEmpty";

export default {
    ADD_PLAN_FINNANCE(state, programmeDinvestissementPlanDeFinancement) {
        state.programmeDinvestissementPlanDeFinancement = programmeDinvestissementPlanDeFinancement;
    },

    ADD_CHIFFRE_AFFAIRE(state, chiffreAffaire) {
        state.caDetails = chiffreAffaire;
    },

    ADD_CA_DETAILS(state, caDetails) {
        if (state.caDetails.type === "CA Total") {
            state.caDetails = {
                offersObject: [],
                type: "CA Détails"
            };
            state.caDetails.offersObject.push(caDetails);
        } else {
            if (!isEmpty(state.caDetails)) {
                let index = state.caDetails.offersObject.findIndex(
                    element => element.id == caDetails.id
                );
                if (index === -1) {
                    state.caDetails.offersObject.push(caDetails);
                } else {
                    state.caDetails.offersObject[index] = caDetails;
                }
            } else {
                state.caDetails = {
                    offersObject: [],
                    type: "CA Détails"
                };
                state.caDetails.offersObject.push(caDetails);
            }
        }
    },

    REMOVE_OFFER(state, id) {
        let index = state.caDetails.offersObject.findIndex(
            caDetails => caDetails.id == id
        );
        if (index !== -1) state.caDetails.offersObject.splice(index, 1);
    },

    REMOVE_ACHAT(state, id) {
        let index = state.achatsPrevisionnel.achats.findIndex(
            caDetails => caDetails.id == id
        );
        if (index !== -1) state.achatsPrevisionnel.achats.splice(index, 1);
    },

    ADD_ACHATS_PREVISIONNEL(state, achatsPrevisionnel) {
        if (state.achatsPrevisionnel.type === "total") {
            state.achatsPrevisionnel = {
                achats: [],
                type: "details"
            };
            state.achatsPrevisionnel.achats.push(achatsPrevisionnel);
        } else {
            if (!isEmpty(state.achatsPrevisionnel)) {
                const index = state.achatsPrevisionnel.achats.findIndex(
                    element => element.id == achatsPrevisionnel.id
                );

                if (index === -1) {
                    state.achatsPrevisionnel.achats.push(achatsPrevisionnel);
                } else {
                    state.achatsPrevisionnel.achats[index] = achatsPrevisionnel;
                }
            } else {
                state.achatsPrevisionnel = {
                    achats: [],
                    type: "details"
                };
                state.achatsPrevisionnel.achats.push(achatsPrevisionnel);
            }
        }
    },

    ADD_ACHATS_PREVISIONNEL_TOTAL(state, achatsPrevisionnel) {
        state.achatsPrevisionnel = achatsPrevisionnel;
    },

    ADD_EVOLUTION_TO_CHIFFRE(state, chiffre) {
        state.TauxEvolutionChiffre = chiffre.tauxEvolution;
        state.TauxRealisationChiffre = chiffre.tauxRealisation;
    },

    ADD_TAUX_ACHATS(state, taux) {
        state.tauxEvolutionAchats = taux;
    },

    ADD_AUTRES_CHARGES(state, autresCharges) {
        state.autresCharges = autresCharges;
    },

    REMOVE_AUTRES_CHARGES(state, id) {
        let index = state.autresCharges.autreCharge.findIndex(
            autresCharges => autresCharges.autreCharge.id == id
        );
        if (index !== -1) state.autresCharges.autreCharge.splice(index, 1);
    },
    ADD_FONCTIONS(state, fonctions) {
        state.fonctions = fonctions;
    },

    REMOVE_FONCTIONS(state, id) {
        let index = state.fonctions.findIndex(fonctions => fonctions.id == id);
        if (index !== -1) state.fonctions.splice(index, 1);
    },

    REMOVE_CHARGES_PREVISONNEL(state, id) {
        let index = state.chargePrevisionnel.findIndex(
            charge => charge.id == id
        );
        if (index !== -1) state.charge.splice(index, 1);
    },

    ADD_CHARGES_PREVISONNEL(state, chargePrevisionnel) {
        state.chargePrevisionnel = chargePrevisionnel;
    },

    PUT_INVESTMENT(state, programmeDinvestissementPlanDeFinancement) {
        state.programmeDinvestissementPlanDeFinancement = programmeDinvestissementPlanDeFinancement;
    },

    PUT_CA_DETAILS(state, caDetails) {
        state.caDetails = caDetails;
    },

    PUT_ACHATS_PREVISIONNEL(state, achatsPrevisionnel) {
        state.achatsPrevisionnel = achatsPrevisionnel;
    },

    PUT_AUTRES_CHARGES(state, autresCharges) {
        state.autresCharges = autresCharges;
    },

    PUT_FONCTIONS(state, fonctions) {
        state.fonctions = fonctions;
    },

    PUT_CHARGES_PREVISONNEL(state, chargePrevisionnel) {
        state.chargePrevisionnel = chargePrevisionnel;
    },

    PUT_TAUX_EVOLUTION_CHIFFRE(state, TauxEvolutionChiffre) {
        state.TauxEvolutionChiffre = TauxEvolutionChiffre;
    },

    PUT_TAUX_REALISATION_CHIFFRE(state, TauxRealisationChiffre) {
        state.TauxRealisationChiffre = TauxRealisationChiffre;
    },

    PUT_TAUX_REALISATION_ACHATS(state, tauxRealisationAchats) {
        state.tauxRealisationAchats = tauxRealisationAchats;
    },

    PUT_TAUX_EVOLUTION_ACHATS(state, tauxEvolutionAchats) {
        state.tauxEvolutionAchats = tauxEvolutionAchats;
    }
};
